import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import moment from 'moment';
import { get_srcip_list as _get_srcip_list, getStatistics, update_app_name } from "../../services/rate/rateS";
export default {
  namespace: "ci0301Info",
  state: {
    yNameA: [],
    xDataA: [],
    yNameB: [],
    xDataB: [],
    step_sn_b: [],
    yNameC: [],
    xDataC: [],
    dataSourceA: [],
    dataSourceB: [],
    dataSourceC: [],
    step_sn: "",
    lineSeriesA: [{
      type: "line",
      data: []
    }],
    tableDataA: [],
    lineSeriesC: [{
      type: "line",
      data: []
    }],
    tableDataC: [],
    srcIpList: [],
    lineSeriesB: [{
      type: "line",
      data: []
    }]
  },
  effects: {
    getStatisticsA: function getStatisticsA(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData, lineSeries, tableData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(getStatistics, payload);
            case 2:
              backData = _context.sent;
              if (!(backData.msg === "ok" || backData.retcode === 0)) {
                _context.next = 10;
                break;
              }
              lineSeries = backData.data.map(function (item, index) {
                var data = [];
                for (var key in item.bands) {
                  data.push([moment.unix(item.bands[key].time).format("YYYY-MM-DD HH:mm:ss"), (item.bands[key].band / 1024).toFixed(4)]);
                }
                return {
                  name: "(" + (index + 1) + "). " + item.app.name,
                  type: "line",
                  id: index,
                  data: data,
                  smooth: true,
                  smoothMonotone: "x",
                  showSymbol: false
                };
              });
              tableData = backData.data.map(function (item) {
                return item.app;
              });
              _context.next = 8;
              return put({
                type: "update",
                payload: {
                  lineSeriesA: lineSeries,
                  tableDataA: tableData
                }
              });
            case 8:
              _context.next = 12;
              break;
            case 10:
              _context.next = 12;
              return put({
                type: "update",
                payload: {
                  lineSeriesA: [{
                    type: "line",
                    data: []
                  }],
                  tableDataA: []
                }
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    getStatisticsB: function getStatisticsB(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData, lineSeries;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(getStatistics, payload);
            case 2:
              backData = _context2.sent;
              if (!(backData.msg === "ok" || backData.retcode === 0)) {
                _context2.next = 10;
                break;
              }
              lineSeries = [];
              backData.data.map(function (item, index) {
                var dataUp = [];
                var dataDown = [];
                for (var key in item.bandwidth) {
                  dataUp.push([moment.unix(item.bandwidth[key].time).format("YYYY-MM-DD HH:mm:ss"), (item.bandwidth[key].ratetx / 1024).toFixed(4)]);
                  dataDown.push([moment.unix(item.bandwidth[key].time).format("YYYY-MM-DD HH:mm:ss"), (item.bandwidth[key].raterx / 1024).toFixed(4)]);
                }
                var lineSeriesPerAgency = [{
                  name: "(" + (index + 1) + "). " + item.agency_name + "-上行",
                  type: "line",
                  id: index + "up",
                  data: dataUp,
                  smoothMonotone: "x",
                  smooth: true,
                  showSymbol: false
                }, {
                  name: "(" + (index + 1) + "). " + item.agency_name + "-下行",
                  type: "line",
                  id: index + "down",
                  data: dataDown,
                  smoothMonotone: "x",
                  smooth: true,
                  showSymbol: false
                }];
                lineSeries = lineSeries.concat(lineSeriesPerAgency);
                return 0;
              });
              _context2.next = 8;
              return put({
                type: "update",
                payload: {
                  lineSeriesB: lineSeries
                }
              });
            case 8:
              _context2.next = 12;
              break;
            case 10:
              _context2.next = 12;
              return put({
                type: "update",
                payload: {
                  lineSeriesB: [{
                    type: "line",
                    data: []
                  }]
                }
              });
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    getTableB: function getTableB(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(getStatistics, payload);
            case 2:
              backData = _context3.sent;
              _context3.next = 5;
              return put({
                type: "update",
                payload: {
                  dataSourceB: backData.data
                }
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    getStatisticsC: function getStatisticsC(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData, lineSeries, tableData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(getStatistics, payload);
            case 2:
              backData = _context4.sent;
              if (!(backData.msg === "ok" || backData.retcode === 0)) {
                _context4.next = 10;
                break;
              }
              lineSeries = backData.data.map(function (item, index) {
                var data = [];
                for (var key in item.bands) {
                  data.push([moment.unix(item.bands[key].time).format("YYYY-MM-DD HH:mm:ss"), (item.bands[key].band / 1024).toFixed(4)]);
                }
                return {
                  name: "(" + (index + 1) + "). " + item.app.name,
                  type: "line",
                  id: index,
                  data: data,
                  smooth: true,
                  smoothMonotone: "x",
                  showSymbol: false
                };
              });
              tableData = backData.data.map(function (item) {
                return item.app;
              });
              _context4.next = 8;
              return put({
                type: "update",
                payload: {
                  lineSeriesC: lineSeries,
                  tableDataC: tableData
                }
              });
            case 8:
              _context4.next = 12;
              break;
            case 10:
              _context4.next = 12;
              return put({
                type: "update",
                payload: {
                  lineSeriesC: [{
                    type: "line",
                    data: []
                  }],
                  tableDataC: []
                }
              });
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    update_app_nameA: function update_app_nameA(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData, backDataA, tableData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(update_app_name, payload.edit);
            case 2:
              backData = _context5.sent;
              if (!(backData.message === "success")) {
                _context5.next = 10;
                break;
              }
              _context5.next = 6;
              return call(getStatistics, payload.refresh);
            case 6:
              backDataA = _context5.sent;
              tableData = backDataA.data.map(function (item) {
                return item.app;
              });
              _context5.next = 10;
              return put({
                type: "update",
                payload: {
                  tableDataA: tableData
                }
              });
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    update_app_nameB: function update_app_nameB(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put,
        select = _ref12.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData, step_sn, backDataB;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(update_app_name, payload.edit);
            case 2:
              backData = _context6.sent;
              _context6.next = 5;
              return select(function (state) {
                return state.ci0301Info.step_sn;
              });
            case 5:
              step_sn = _context6.sent;
              if (!(backData.message === "success")) {
                _context6.next = 13;
                break;
              }
              if (payload.refresh.step_sn === "") {
                payload.refresh.step_sn = step_sn;
              }
              _context6.next = 10;
              return call(getStatistics, payload.refresh);
            case 10:
              backDataB = _context6.sent;
              _context6.next = 13;
              return put({
                type: "update",
                payload: {
                  dataSourceB: backDataB.data
                }
              });
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    update_app_nameC: function update_app_nameC(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put,
        select = _ref14.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData, backDataC, tableData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(update_app_name, payload.edit);
            case 2:
              backData = _context7.sent;
              if (!(backData.message === "success")) {
                _context7.next = 10;
                break;
              }
              _context7.next = 6;
              return call(getStatistics, payload.refresh);
            case 6:
              backDataC = _context7.sent;
              tableData = backDataC.data.map(function (item) {
                return item.app;
              });
              _context7.next = 10;
              return put({
                type: "update",
                payload: {
                  tableDataC: tableData
                }
              });
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    get_srcip_list: function get_srcip_list(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData, srcIpList;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_get_srcip_list, payload);
            case 2:
              backData = _context8.sent;
              if (!(backData.msg === "ok" || backData.retcode === 0)) {
                _context8.next = 7;
                break;
              }
              srcIpList = backData.data.map(function (item) {
                return {
                  src_ip: item,
                  dst_ip: payload.dst_ip,
                  dst_port: payload.dst_port,
                  name: payload.name
                };
              });
              _context8.next = 7;
              return put({
                type: "update",
                payload: {
                  srcIpList: srcIpList
                }
              });
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};